document.addEventListener("DOMContentLoaded", () => {
  if (!document.body.classList.contains("template-product")) return;

  // Lazy load Yotpo
  const yotpoScript = document.createElement("script");
  yotpoScript.src = "https://cdn-widgetsrepository.yotpo.com/bundle.js";
  yotpoScript.defer = true;
  document.body.appendChild(yotpoScript);

   //------------------------
  // Lazy-load Clarity
  //------------------------
  function loadClarity() {
    if (window.clarityLoaded) return;
    window.clarityLoaded = true;

    (function(c,l,a,r,i,t,y){
      c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
      t=l.createElement(r); t.async=1;
      t.src="https://www.clarity.ms/tag/fzfkgplucw";
      y=l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "fzfkgplucw");
  }

  //------------------------
  // Lazy-load Hotjar
  //------------------------
  function loadHotjar() {
    if (window.hotjarLoaded) return;
    window.hotjarLoaded = true;

    (function(h,o,t,j,a,r){
      h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
      h._hjSettings={hjid:1464667,hjsv:6};
      a=o.getElementsByTagName('head')[0];
      r=o.createElement('script'); r.async=1;
      r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
      a.appendChild(r);
    })(window, document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
  }



  //------------------------
  // Trigger 3rd-party scripts on first user interaction
  //------------------------
  function triggerThirdPartyScripts() {
    loadClarity();
    loadHotjar();
  }

  ['scroll', 'mousemove', 'keydown', 'touchstart', 'click'].forEach(evt => {
    window.addEventListener(evt, triggerThirdPartyScripts, { once: true, passive: true });
  });
});